import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VDataTable, {
    attrs: {
      headers: _vm.tabela.headers,
      items: _vm.relatoriosPreferencias,
      search: _vm.tabela.opcoes.pesquisa,
      "sort-by": _vm.tabela.opcoes.ordenarPor,
      "sort-desc": _vm.tabela.opcoes.decrescente,
      "item-key": "id",
      "show-expand": "",
      "single-expand": "",
    },
    scopedSlots: _vm._u(
      [
        {
          key: "top",
          fn: function () {
            return [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("app-sort", {
                        model: {
                          value: _vm.tabela.opcoes,
                          callback: function ($$v) {
                            _vm.$set(_vm.tabela, "opcoes", $$v)
                          },
                          expression: "tabela.opcoes",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(VSpacer),
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("app-search", {
                        model: {
                          value: _vm.tabela.opcoes,
                          callback: function ($$v) {
                            _vm.$set(_vm.tabela, "opcoes", $$v)
                          },
                          expression: "tabela.opcoes",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: `item.data-table-expand`,
          fn: function ({ item, expand, isExpanded }) {
            return [
              _c(
                VTooltip,
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              VBtn,
                              _vm._g(
                                {
                                  attrs: {
                                    height: "100%",
                                    text: "",
                                    width: "100%",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return expand(!isExpanded)
                                    },
                                  },
                                },
                                on
                              ),
                              [
                                _c(
                                  VBadge,
                                  {
                                    attrs: { right: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "badge",
                                          fn: function () {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(item.itemA.quantidade)
                                                ),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("h1", { staticClass: "h1 grey--text" }, [
                                      _vm._v("A"),
                                    ]),
                                  ]
                                ),
                                _c(
                                  VBadge,
                                  {
                                    attrs: { right: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "badge",
                                          fn: function () {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(item.itemB.quantidade)
                                                ),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "h1",
                                      { staticClass: "h1 grey--text ml-8" },
                                      [_vm._v("B")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [_c("span", [_vm._v("Clique para exibir as repostas")])]
              ),
            ]
          },
        },
        {
          key: "expanded-item",
          fn: function ({ headers, item }) {
            return [
              _c(
                "td",
                {
                  staticClass: "justify-center",
                  attrs: { colspan: headers.length },
                },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(VSpacer),
                      _c(
                        VCol,
                        [
                          _c(
                            VRow,
                            { staticClass: "justify-center" },
                            [
                              _c("app-title", {
                                attrs: { texto: "RESPOSTAS" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VSpacer),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(VSpacer),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          _c(
                            _vm.isGeral ? "ExpansaoGeral" : "ExpansaoUnidade",
                            {
                              tag: "component",
                              attrs: {
                                "item-a": item.itemA,
                                "item-b": item.itemB,
                                respostas: item.respostas,
                              },
                            }
                          ),
                        ],
                        1
                      ),
                      _c(VSpacer),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }